module.exports = __webpack_public_path__ + "img/ce5.b0b1d903.png";